var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_1310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8995 14.1982H38.2303C39.2065 14.1982 39.9976 15.0036 39.9976 15.9968V25.5733C39.9976 29.2238 37.0897 32.1834 33.5026 32.1834H33.4718C29.8847 32.1838 26.9763 29.2249 26.9758 25.5742V15.1384C26.9758 15.0149 26.9996 14.8927 27.046 14.7786C27.0924 14.6645 27.1604 14.5608 27.2462 14.4735C27.332 14.3862 27.4338 14.317 27.5459 14.2697C27.658 14.2225 27.7782 14.1982 27.8995 14.1982Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8822 12.3054C37.1938 12.3054 39.0678 10.3983 39.0678 8.04579C39.0678 5.69325 37.1938 3.78613 34.8822 3.78613C32.5705 3.78613 30.6965 5.69325 30.6965 8.04579C30.6965 10.3983 32.5705 12.3054 34.8822 12.3054Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8603 12.3056C25.1994 12.3056 27.9062 9.55093 27.9062 6.15282C27.9062 2.75471 25.1994 0 21.8603 0C18.5213 0 15.8145 2.75471 15.8145 6.15282C15.8145 9.55093 18.5213 12.3056 21.8603 12.3056Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9217 14.1982H12.8687C11.9043 14.2226 11.1414 15.0371 11.1638 16.0186V26.9411C11.0291 32.831 15.6078 37.7187 21.3951 37.8629C27.1825 37.7187 31.7612 32.831 31.6266 26.9411V16.0186C31.649 15.0371 30.8861 14.2226 29.9217 14.1982Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.3253 14.1982V29.5045C22.323 29.8478 22.2212 30.1827 22.0326 30.4674C21.8439 30.752 21.5769 30.9736 21.2649 31.1043C21.0618 31.1917 20.8436 31.2367 20.6231 31.2367H11.9821C11.8611 30.9243 11.7496 30.6119 11.6565 30.2902C11.3309 29.204 11.1648 28.0748 11.1636 26.9392V16.0157C11.1412 15.0358 11.9029 14.2226 12.8657 14.1984L22.3253 14.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.3952 14.1982V30.4511C21.3952 30.6755 21.351 30.8976 21.2651 31.1043C21.1367 31.4217 20.9189 31.6935 20.6393 31.8855C20.3596 32.0775 20.0304 32.1811 19.6931 32.1834H12.4197C12.2616 31.8709 12.1127 31.5585 11.9826 31.2367C11.8575 30.9273 11.7488 30.6114 11.657 30.2902C11.3314 29.204 11.1653 28.0748 11.1641 26.9392V16.0157C11.1417 15.0358 11.9033 14.2226 12.8662 14.1984L21.3952 14.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.3952 14.1982V28.5579C21.3881 29.5116 20.6302 30.2831 19.693 30.2902H11.6567C11.3311 29.204 11.165 28.0748 11.1638 26.9392V16.0157C11.1415 15.0358 11.9031 14.2226 12.866 14.1984L21.3952 14.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.4651 14.1982V28.5579C20.4579 29.5116 19.7 30.2831 18.763 30.2902H11.6567C11.3311 29.204 11.165 28.0748 11.1638 26.9392V16.0157C11.1415 15.0358 11.9031 14.2226 12.866 14.1984L20.4651 14.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.3254 9.30453V12.2862C22.1673 12.2957 22.0184 12.3053 21.8603 12.3053C21.7022 12.3053 21.5533 12.2957 21.3952 12.2862C21.0813 12.265 20.77 12.2143 20.4652 12.1348C19.5366 11.911 18.6733 11.4667 17.9458 10.8382C17.2183 10.2098 16.6474 9.41502 16.2796 8.51893C16.1511 8.21367 16.0515 7.89669 15.9819 7.57227H20.6233C21.5618 7.57592 22.3218 8.34928 22.3254 9.30453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.3951 10.2516V12.2868C21.0811 12.2656 20.7698 12.2149 20.465 12.1354C19.5365 11.9116 18.6732 11.4673 17.9457 10.8388C17.2183 10.2104 16.6473 9.4156 16.2795 8.51953H19.6929C20.6316 8.52303 21.3915 9.29654 21.3951 10.2516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.3951 10.2516V12.2868C21.0811 12.2656 20.7698 12.2149 20.465 12.1354C19.5365 11.9116 18.6732 11.4673 17.9457 10.8388C17.2183 10.2104 16.6473 9.4156 16.2795 8.51953H19.6929C20.6316 8.52303 21.3915 9.29654 21.3951 10.2516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.4652 10.2518V12.1356C19.5366 11.9117 18.6733 11.4674 17.9458 10.8389C17.2183 10.2105 16.6473 9.41565 16.2795 8.51953H18.763C19.7017 8.52319 20.4616 9.2967 20.4652 10.2518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70716 8.51871H18.7599C19.7017 8.51871 20.4651 9.29557 20.4651 10.2538V27.6084C20.4651 28.5667 19.7017 29.3435 18.7601 29.3435H1.70716C0.765549 29.3435 0.00219727 28.5667 0.00219727 27.6084V10.254C0.00219727 9.29541 0.765549 8.51871 1.70716 8.51871Z",
    fill: "url(#paint0_linear_108_1310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7207 15.1246H11.3117V24.5715H9.13988V15.1246H5.74683V13.292H14.7207V15.1246Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_1310",
    x1: 355.483,
    y1: -127.052,
    x2: 1726.25,
    y2: 2205.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_1310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeams);
export default __webpack_public_path__ + "static/media/ic_teams.1377358d68463a8ac2630867f0cf4650.svg";
export { ForwardRef as ReactComponent };